import noop from 'lodash/noop';
import { Fragment } from 'react';

import { NavigationItemContent } from 'applications/GSP/layouts/MainLayout/components/Sidebar/components/components/NavigationItemContent';
import { NAVIGATION_ANALYTICS_EVENT } from 'applications/GSP/layouts/MainLayout/components/Sidebar/constants';

import { NavigationItemWrapper } from './components/NavigationItemWrapper';
import { NavigationListWrapper } from './components/NavigationListWrapper';

import type {
  NavigationItem,
  SidebarAnimatedComponentsState,
} from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';
import type { AnalyticsEvent } from 'applications/GSP/shared/constants/analytics';
import type { FC } from 'react';

interface NavigationSectionProps extends SidebarAnimatedComponentsState {
  navigationItems: NavigationItem[];
  onActive?(event: AnalyticsEvent): void;
}

export const NavigationSection: FC<NavigationSectionProps> = ({
  opened,
  navigationItems,
  onActive = noop,
}) => (
  <NavigationListWrapper opened={opened}>
    {navigationItems.map(({ label, icon, to, disabled, sidebarType }) => (
      <Fragment key={to}>
        <NavigationItemWrapper
          opened={opened}
          to={to}
          disabled={disabled}
          sidebarType={sidebarType}
          onActive={() => onActive(NAVIGATION_ANALYTICS_EVENT[to])}
        >
          {({ isActive }) => (
            <NavigationItemContent
              isActive={isActive}
              sidebarType={sidebarType}
              label={label}
              icon={icon}
              opened={opened}
              disabled={disabled}
            />
          )}
        </NavigationItemWrapper>
      </Fragment>
    ))}
  </NavigationListWrapper>
);
